import type {
  PaywallPrice,
  PaywallPriceInterval,
} from "@/react/types/PaywallPrice";
import { INTERVAL_OPTION_MAPPER } from "./constants";
import type { IntervalOption } from "./constants";

interface PaywallPriceWithTempId extends Omit<PaywallPrice, "id"> {
  id?: number;
  interval_label?: string;
  tempId?: string;
}

interface NewPaywallPrice {
  amount: number;
  id?: number;
  interval: PaywallPriceInterval | undefined;
  interval_count: number | undefined;
  interval_label: string;
  preferred: boolean;
  price_type: string;
  tempId: string;
}

export const addButtonLocked = (
  amount: string | number,
  intervalOption: IntervalOption,
  currentPaywallPrices: (PaywallPriceWithTempId | NewPaywallPrice)[],
  pricesMaxCount: number,
): boolean => {
  const duplicatedCurrentPrice = currentPaywallPrices.find(
    paywallPrice =>
      paywallPrice.amount === Math.round(Number(amount) * 100) &&
      paywallPrice.interval ===
        INTERVAL_OPTION_MAPPER[intervalOption].interval &&
      paywallPrice.interval_count ===
        INTERVAL_OPTION_MAPPER[intervalOption].interval_count,
  );

  return (
    String(amount).length < 1 ||
    currentPaywallPrices.length > pricesMaxCount - 1 ||
    !!duplicatedCurrentPrice
  );
};
